import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function AdminNavBar() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        px: 2,
        py: 1,
        backgroundColor: '#f7f7f7',
        borderBottom: '1px solid #ddd',
      }}
    >
      <Button component={Link} to="/notifications" size="small">
        Notifications
      </Button>
      <Button component={Link} to="/discounts" size="small">
        Discounts
      </Button>
      <Button component={Link} to="/reseller-codes" size="small">
        Reseller Codes
      </Button>
      <Button component={Link} to="/transactions" size="small">
        Transactions
      </Button>
      <Button component={Link} to="/webhooks" size="small">
        Webhooks
      </Button>
      <Button component={Link} to="/users" size="small">
        Users
      </Button>
    </Box>
  );
}
